/**
 * Create Favourites context for custom hook
 */
import { createContext } from 'react'

const FavouritesContext = createContext({
  addToFavourite: () => {},
  fetchFavourites: () => {},
  removeFromFavourite: () => {}
})

export default FavouritesContext
